module.exports = __webpack_public_path__ + "static/media/meettrainer_photo.cadb92e0.jpg";